import { createElement } from 'react';
import { Route } from 'react-router';
import AngularRouteFetcher from '../../../routing/AngularRouteFetcher';
import { childRoutes } from '../../../routing/angularRoutes';

export function getAngularChildRoutes(routes) {
    return routes.map(route =>
        createElement(Route, {
            exact: true,
            path: route,
            key: route,
            render: ({ match }) => <AngularRouteFetcher match={match} stateGetter={childRoutes[route]} />,
        })
    );
}
